import SqApp from "@sqreem-frontend/sqapp"

// Styles
import "./styles/App.scss";
import Routes from "./routes/Routes";
import { useDispatch } from "react-redux";
import MainServices from "./services/Main.services";
import { AiOutlineBook } from "react-icons/ai";
import { getAnalysisList, getMarketPackages, getQuickReports, setIsAppLoaded } from "./store/components/BuildTargets.slice";
import OneIntelligenceServices from "./services/OneIntelligence.services";
import MarketExplorerServices from "./services/MarketExplorer.services";
import ConfigServices from "./services/Config.services";
import { Button } from "antd";
import InsightsSubcriptionButton from "../src/customcomponents/subscription/InsightsSubcriptionButton";
import { useSelector } from "react-redux";
import AppMenu from "../src/customcomponents/appmenu/AppMenu";
import { useState } from "react";
import useWhiteLabelLogo from "./customcomponents/whitelabel/useWhiteLabelLogo";
import useWhiteLabelFooter from "./customcomponents/whitelabel/useWhiteLabelFooter";
import { parseBoolean } from "./utils/MainHelper";

const App = () => {
  const dispatch = useDispatch()
  const { isAppLoaded } = useSelector((state) => state.buildTargets)
  const [accountID, setAccountID] = useState(null)

  const imageLogo = useWhiteLabelLogo(accountID)
  const footerPrefix = useWhiteLabelFooter()

  const isViewer = parseBoolean(process.env.REACT_APP_ISVIEWER)
  const appName = process.env.REACT_APP_NAME || "ONE Intelligence"
  const props = {
    // appName,
    appName: isViewer ? "ONE Intelligence Viewer" : "",
    appId: 3,
    version: process.env.REACT_APP_VERSION || "v01.00.00",
    appLogDetails: {
      appName
    },
    router: {
      routes: Routes(),
      navigateTo: isViewer ? undefined : "buildtargets",
    },
    theme: {
      default: "light"
    },
    footer: {
      prefix: footerPrefix
    },
    loggerApp: false,
    header: {
      imageLogo,
      menubar: isViewer ? null : <AppMenu />,
      toolbar: isViewer ? null : <div
        className="d-flex align-items-center justify-content-end"
        style={{
          height: "100%"
        }}
      >
        {isAppLoaded && <InsightsSubcriptionButton />}
        <Button
          style={{ backgroundColor: "transparent", color: "white", padding: "1mm 2mm" }}
          type="text"
          onClick={() => {
            window.open("https://oneintelligence.sqreemtech.com/userguide/SQ ONE Intelligence Guide.pdf", "_blank");
          }}
        >
          <div className="d-flex align-items-center gap-5p">
            <AiOutlineBook />
            <span>User Guide</span>
          </div>
        </Button>
        <span style={{ color: "white" }}>|</span>
      </div>,
    },
    accessApp: !isViewer,
    onLoadSuccess: async (userInfo) => {
      console.log(userInfo)
      setAccountID(userInfo?.accountDetails?.id)
      dispatch(setIsAppLoaded(true))
      window.sq = {
        oneintel: {
          appName,
          isLoadedAnalysis: false,
          listOfOngoingApiCalls: {}
        }
      }
      window.useS3Cache = true;
      window.useInternalLink = false;

      await ConfigServices.getAdminUsers();
      await ConfigServices.getWhiteLabelDictionary();
      
      if (!isViewer) {
        MainServices.userDetails(userInfo);
        MainServices.setFeatureAccess(userInfo);
        // await dispatch(getFeatures())
        await dispatch(getAnalysisList())
        await dispatch(getMarketPackages())
        await dispatch(getQuickReports())
        await MarketExplorerServices.loadMarketExplorerListConfig()
        await OneIntelligenceServices.loadSavantUrls()
        // await ConfigServices.loadAnalysisListConfig()
        await ConfigServices.loadAnalysisDetails()

        // need
        await ConfigServices.loadTreePermission();
        await ConfigServices.getDefaultSelectionsCofig(true);

      } else {
        const { hash } = new URL(window.location.href)
        const tempHash = hash.substring(1);
        if (tempHash) {
          window.sq.oneintel.hash = tempHash
        }
      }

      ConfigServices.getBrandsListToFilter()
    },
  };

  return <SqApp {...props} />;
};
export default App;
